import React from 'react';
import { VideoLandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingMpegToMp3ConverterConfig } from '@/data/landingConfig/landingMpegToMp3ConverterConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_MpegToMp3Converter } from './schemaObject';

interface Props {}
const MpegToMp3Converter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_MpegToMp3Converter} />
			<VideoLandingTemplate
				data={landingMpegToMp3ConverterConfig}
				funnelLinkService={GenerateLandingLinkService.funnelVideoConverter()}
			/>
		</>
	);
};

export default MpegToMp3Converter;
